export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

// TODO MARIANO: add REAL testimonials here (same format as the police landing).
// While this list is empty, the page shows a marked placeholder in this section.
// Before publishing: add real testimonials OR set SHOW_TESTIMONIAL_PLACEHOLDER to false.
export const SHOW_TESTIMONIAL_PLACEHOLDER = true;

export const testimonials: Testimonial[] = [];
